/**
 * Na klik op Rebuy "Toevoegen" knop: cart drawer verversen
 * Rebuy voegt product asynchroon toe; we wachten even en triggeren dan refresh
 */
(function() {
  document.addEventListener('click', function(e) {
    if (e.target.closest('.rebuy-button')) {
      setTimeout(function() {
        document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
      }, 1500);
    }
  });
})();
